import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from 'components/Common/Breadcrumb2';
import CreateChapter from './CreateChapter';
import Cookies from 'js-cookie';
import { 
  fetchModulesRequest, 
  fetchChaptersRequest, 
  addChapterRequest, 
  getRoles, 
  fetchCoursesRequest
} from 'store/actions';
import ChapterTable from './ChapterTable';

const ChapterList = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const chapters = useSelector(state => state.Chapter.chapters);
  const modules = useSelector(state => state.Module.modules);
  const courses = useSelector(state => state.Course.courses);
  const loading = useSelector(state => state.Chapter.loading);
  const error = useSelector(state => state.Chapter.error);

  const roles = useSelector(state => state?.Role.roles);
  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasAddPermission = permissions?.some(item => item?.permission_name == 'Add Chapter');

  useEffect(() => { 
    dispatch(fetchCoursesRequest())
    dispatch(getRoles());
  }, [dispatch]);

  const handleSubmit = (data, onClose) => {
    dispatch(addChapterRequest(data, onClose));
  };

  const courseOptions = courses?.data?.map(course => ({
    value: course._id,
    label: course.title
  })) || [];

  return (
    <>
      <CreateChapter
        visible={isOpen}
        handleClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
        courseOptions={courseOptions}
      />

      <div className="page-content container-fluid">
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Chapters"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Chapters', link: '#' }
            ]}
          />
          {hasAddPermission && (
            <Button
              className="bg-primary text-white d-flex align-items-center gap-1"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> Add New
            </Button>
          )}
        </div>

        <ChapterTable
          chapters={chapters?.data || []}
          totalrows={chapters?.total}
          loading={loading}
          error={error}
          modules={modules?.data}
          courseOptions={courseOptions}
        />
      </div>
    </>
  );
};

export default ChapterList;
